<template>
  <div v-if="shouldShow" class="leaderboard-cell" :class="[cellContent.isSelf? 'outlined': '', cellContent.type]">
    <AngledNineGrid :show="show" :refreshCount="refreshCount" :background="bg"/>
    <img v-if="cellContent.isSelf === false && cellContent.type === 'buddyName' && cellContent.index === 0"
         src="~@/assets/image/icons/icon_anonbud_gold.svg" alt="" class="buddy-icon">
    <img v-if="cellContent.isSelf === false && cellContent.type === 'buddyName' && cellContent.index === 1"
         src="~@/assets/image/icons/icon_anonbud_silver.svg" alt="" class="buddy-icon">
    <img v-if="cellContent.isSelf === false && cellContent.type === 'buddyName' && cellContent.index === 2"
         src="~@/assets/image/icons/icon_anonbud_bronze.svg" alt="" class="buddy-icon">
    <img v-if="cellContent.isSelf === false && cellContent.type === 'buddyName' && cellContent.index > 2 "
         src="~@/assets/image/icons/icon_anonbud_other.svg" alt="" class="buddy-icon">
    <img v-if="cellContent.isSelf === true && cellContent.type === 'buddyName'"
         src="~@/assets/image/icons/icon_anonbud_sameschool.svg" alt="" class="buddy-icon">
    <p>{{ displayText }}</p>
  </div>
</template>

<script>

import AngledNineGrid from "@/components/UI/AngledNineGrid.vue";

export default {
  name: "LeaderboardCell",
  components: {AngledNineGrid},
  props: {
    cellContent: Object,
    show: Boolean,
  },
  data() {
    return {
      refreshCount: 0,

    }
  },
  computed: {
    shouldShow() {
      if (!this.cellContent.show) return false;
      
      let type = this.cellContent.type;

      if (this.cellContent.set === 'school') {
        return type === 'index' || type === 'buddyName' || type === 'activityCount' || type === 'class';
      } else {
        return type === 'index' || type === 'buddyName' || type === 'activityCount' || type === 'school' || type === 'city';
      }
    },
    bg() {
      if (this.cellContent.index === 0) {
        return 'rgba(255,194,41,0.8)';
      } else if (this.cellContent.index === 1) {
        return 'rgba(168,168,168,0.8)';
      } else if (this.cellContent.index === 2) {
        return 'rgba(231,127,88,0.8)';
      } else if (this.cellContent.isSelf) {
        return 'rgba(79,106,189,1)';
      } else if (this.cellContent.sameSchool) {
        return 'rgba(67,109,181,0.6)';
      }

      return 'rgba(0,0,47,0.6)';
    },
    displayText() {
      if (this.cellContent.type === 'index') {
        if (this.cellContent.index < 10) {
          return '0' + this.cellContent.text;
        } else {
          return this.cellContent.text;
        }
      }


      return this.cellContent.text;
    },
    
  },

  mixins: [],
  methods: {},
  mounted() {
    this.refreshCount++;
  },
  created() {

  }
}


</script>

<style lang="scss" scoped>

.leaderboard-cell {
  height: 100%;
  position: relative;
  padding: 0 1%;
  max-width: 97%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  p {
    font-family: "Flanders Art Sans", sans-serif;
    font-weight: bold;
    color: #fff;
    margin: 0;
    //white-space: nowrap;
    //overflow: hidden;
    //text-overflow: ellipsis;

    @media (max-width: 1499px) {
      font-size: 0.9em;
    }

    @media (max-width: 1999px) and (min-width: 1500px) {
      font-size: 1.2em;
    }

    @media (min-width: 2000px) {
      font-size: 1.9em;
    }
  }
}

.outlined {
  outline: white 2px solid;
}

.index {
  p {
    width: auto !important;
    text-align: center;
  }
}

.buddyName, .activitiesCount, .class, .school, .city {
  justify-content: flex-start;

  p {
    width: 100%;
    text-align: left;
  }
}

.buddyName {
  p {
    padding-left: 8%;
  }
}

.school {
  .buddyName {
    p {
      padding-left: 15%;
    }
  }
}


.buddy-icon {
  height: 99%;
  width: auto;
  position: absolute;
  left: 0%;

}


</style>